import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import * as React from 'react'
import { ServiceItem } from '@/cms/fields/types/checkout-page'
import { useIntl } from '@/intl'
import { CheckoutSection } from '@/scopes/checkout/components/CheckoutSection'
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks'
import { shouldShowRyanairTermsAndConditions } from '@/scopes/checkout/domain/policies/airline'
import { getRyanairTermsAndConditionsLinks } from '@/scopes/checkout/domain/policies/siteName'
import { getAirlinesNames } from '@/scopes/checkout/pages/selectors'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { CheckboxInput } from '../../../common/components/FormElements/CheckboxInput'

interface GeneralTermsAndConditionsProps {
  items: ServiceItem[]
  fieldName: string
}

export function GeneralTermsAndConditions({
  items,
  fieldName,

}: GeneralTermsAndConditionsProps) {
  const intl = useIntl()
  const { data } = useBookingDraftQuery()
  const airlinesNames = getAirlinesNames(data?.transportInfo)
  const showRyanairTermsAndConditions = shouldShowRyanairTermsAndConditions(airlinesNames)
  const siteName = useConfiguration('siteName')
  const ryanairLinks = getRyanairTermsAndConditionsLinks(siteName)

  return (
    <form>
      { items.map((item, index) => {
        let termsAndConditionsContent = item.componentDescription

        if (showRyanairTermsAndConditions && ryanairLinks && index === 0) {
          termsAndConditionsContent += `<br/> <br/> ${intl.formatMessage({ id: 'checkout_steps_general_terms_and_conditions_ryanair_additional_message' }, {
            termsAndConditionsLink: ryanairLinks.termsAndConditions ? buildLink(ryanairLinks.termsAndConditions, intl.formatMessage({ id: 'checkout_steps_terms_and_conditions_ryanair_general' })) : '',
            termsOfUseLink: ryanairLinks.termsOfUse ? buildLink(ryanairLinks.termsOfUse, intl.formatMessage({ id: 'checkout_steps_terms_and_conditions_ryanair_terms_of_use' })) : '',
            privacyPolicyLink: ryanairLinks.privacyPolicy ? buildLink(ryanairLinks.privacyPolicy, intl.formatMessage({ id: 'checkout_steps_terms_and_conditions_ryanair_privacy' })) : '',
            cookiePolicyLink: ryanairLinks.cookiePolicy ? buildLink(ryanairLinks.cookiePolicy, intl.formatMessage({ id: 'checkout_steps_terms_and_conditions_ryanair_cookie' })) : '',
            noticeLink: ryanairLinks.notice ? buildLink(ryanairLinks.notice, intl.formatMessage({ id: 'checkout_steps_terms_and_conditions_ryanair_notice' })) : '',
          })}`
        }

        return (
          <CheckoutSection key={item.componentId} title={item.componentTitle ?? ''} glyph="DocumentWithText">
            <CheckboxInput
              label={<RichText innerHTML={termsAndConditionsContent} />}
              name={`${fieldName}.${item.componentId}`}
              validationMessage={intl.formatMessage({ id: 'checkout_steps_general_terms_and_conditions_required_error_message' })}
            />
          </CheckoutSection>
        )
      },
      )}
    </form>
  )
}

function buildLink(url: string, text: string) {
  if (!url) {
    return ''
  }
  return `<a href="${url}" target=\"_blank\">${text}</a>`
}
